import {NgModule, Pipe, PipeTransform} from '@angular/core';
declare let _: any;
import {TranslateService} from "@ngx-translate/core";
@Pipe({
    name: 'replaceTokensArray',
    standalone: false
})
export class ReplaceTokensArrayPipe implements PipeTransform {

    constructor(protected translateSvc:TranslateService){}
    transform(value: any, {keys, previewVar = '', prefix = '%%', sufix = '%%'}): any {
        if (!keys) {return value;}
        if(!value) {return  ''};
        const regexp = /%%(.*?[^|%]+)(?:\|([^|%]+))?%%/g;
        const regexCondition = /\[(.*?)\]/g;
        const evalRegex = /\{(.*?)\}/g;

        value = value.replace(regexp, ($1, $2, $3) => {
            let fieldVal = _.get(keys, $2);
            if($3 == 'translate') {
                fieldVal = this.translateSvc.instant($2)
            }
            if ($3 == 'encode' && fieldVal) {
                fieldVal = encodeURIComponent(fieldVal);
            }
            if ($3 == 'base64' && fieldVal) {
                return this.b64DecodeUnicode(fieldVal);
            }
            switch (true) {
                case regexCondition.test($2):
                    return this.eval($2, keys, regexCondition, true);
                case evalRegex.test($2):
                    return this.eval($2, keys, evalRegex);
                case $3 && typeof $3 === 'string' && $3.startsWith('separator:'):
                    if (Array.isArray(fieldVal)) {
                        const extractType = $3.split(':')[1];
                        return fieldVal.join( extractType || ', ');
                    }
                    return '';
                case !fieldVal:
                    return '';
                case Array.isArray(fieldVal):
                    return fieldVal.join(', ');
                case $2 && $2.endsWith(`_base64`):
                    return this.b64DecodeUnicode(fieldVal);
                case /"/.test(fieldVal):
                    return  fieldVal.replace(/\"/g, '&quot;');
                default:
                    return  fieldVal;
            }
        });
        return previewVar? `<!--Start render ${previewVar} block preview, data from ${this.findDocType(keys)}-->\n${value}<!--end>` : value;
    }


    findDocType(doc) {
        switch (doc['solr_doc_type_s']) {
            case 'product':
                return `product_id_i:${doc['product_id_i']} solr doc, type=${doc['solr_doc_type_s']} `;
            case 'media':
                return `media_id_i:${doc['media_id_i']} solr doc, type=${doc['solr_doc_type_s']} `;
            default:
                if(doc['entity_var_s']) {
                    return `entity_var_s:${doc['entity_var_s']} solr doc, type=${doc['solr_doc_type_s'] || 'entity'} `;
                }
                return '';
        }
    }

    b64DecodeUnicode(str) {
        try {
            return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        } catch (e) {
            return '';
        }
    }

    eval(str, keys, rgx, asCondition = false) {
        let code = str.replace(rgx, (_,k) =>{
            return keys[k] ? "'" + keys[k].toString().replace(/\'/g, '&apos;').replace(/\n|\r/g, '') + "'" : null;
        });
        return Function("return " + (asCondition ? "!!" : "") + "(" + code + ")" )();
    }
}

@NgModule({
    declarations: [ReplaceTokensArrayPipe],
    exports: [ReplaceTokensArrayPipe]
})
export class ReplaceTokensPipeArrayModule {}
